// extracted by mini-css-extract-plugin
export default {"container":"BqT9w","image":"WYTH2","text":"Aalas","title":"gaVY6","value":"hZxJf","button":"Rro44"};